export const bpToDecimal = (bp: number) => {
  return bp / 10000;
};
